<div class="wireless-account-authentication-container flex flex-column gap-3 mb-5">

  <div class="flex flex-column gap-2">
    <span class="title text-lg font-bold">
      <app-translate key="WIRELESS_ACCOUNT_AUTHENTICATION_TITLE"></app-translate>
    </span>
    <span class="text-sm text-color-secondary">
      <app-translate key="WIRELESS_ACCOUNT_AUTHENTICATION_SUBTEXT"></app-translate>
    </span>
  </div>

  @if (connectionError) {
    <app-error-banner [title]="languageService.getTranslation('CONNECTION_ERROR_TITLE')"
    [message]="languageService.getTranslation('CONNECTION_ERROR_MESSAGE')"></app-error-banner>
  }

  <!-- Stepper track: segmented progress bar. gray = not complete, blue = current, green = completed -->
  <div class="stepper-track flex align-items-center gap-2 px-2">
    <div class="stepper-segment border-round" [ngClass]="step1Status()"></div>
    <div class="stepper-segment border-round" [ngClass]="step2Status()"></div>
    <div class="stepper-segment border-round" [ngClass]="step3Status()"></div>
  </div>

  <div class="flex flex-column gap-3">

    <!-- ===================== STEP 1: Find & Validate Account ===================== -->
    <div class="step-container border-round p-3 mb-2" [ngClass]="step1Status()">
      <div class="step-header flex align-items-center gap-2">
        <span class="step-pill border-round">
          <app-translate key="STEP_1_OF_3"></app-translate>
        </span>
        @if (!isAccountValidated) {
          <span class="font-semibold">
            <app-translate key="FIND_AND_VALIDATE_ACCOUNT"></app-translate>
          </span>
        }
        @if (isAccountValidated) {
          <span class="font-semibold text-green-600 flex align-items-center gap-1">
            <i class="pi pi-check-circle"></i>
            <app-translate key="ACCOUNT_VALIDATED"></app-translate>
          </span>
        }
      </div>

      <app-account-lookup [wirelessSetupCustomerOrderPayload]="wirelessSetupCustomerOrderPayload"
        [connectionId]="ConnectionId" (accountValidated)="onAccountValidated($event)"
        (clearSelectionRequested)="onClearSelectionRequested()"
      (connectionError)="onConnectionError()"></app-account-lookup>
    </div>

    <!-- ===================== STEP 2: Send One-Time Pin (OTP) ===================== -->
    <div class="step-container border-round p-3 mb-2" [ngClass]="step2Status()" [class.disabled]="!isAccountValidated">
      <div class="step-header flex align-items-center gap-2">
        <span class="step-pill border-round">
          <app-translate key="STEP_2_OF_3"></app-translate>
        </span>
        <span class="font-semibold">
          <app-translate key="SEND_ONE_TIME_PIN"></app-translate>
        </span>
      </div>

      <div class="pt-2">
        <span class="text-sm text-color-secondary">
          <app-translate key="OTP_REQUIRED_DESCRIPTION"></app-translate>
        </span>
      </div>

      <app-otp-delivery [wirelessSetupCustomerOrderPayload]="wirelessSetupCustomerOrderPayload"
        [accountNumber]="accountNumber" [pinDeliveryOptions]="pinDeliveryOptions"
        [isAccountValidated]="isAccountValidated" (pinSent)="onPinSent($event)"
      (pinExpired)="onPinExpired()" (connectionError)="onConnectionError()"></app-otp-delivery>
    </div>

    <!-- ===================== STEP 3: Validate Pin ===================== -->
    <div class="step-container border-round p-3 mb-2" [ngClass]="step3Status()" [class.disabled]="!showPinFields">
      <div class="step-header flex align-items-center gap-2">
        <span class="step-pill border-round">
          <app-translate key="STEP_3_OF_3"></app-translate>
        </span>
        @if (!isPinValidated) {
          <span class="font-semibold">
            <app-translate key="VALIDATE_PIN"></app-translate>
          </span>
        }
        @if (isPinValidated) {
          <span class="font-semibold text-green-600 flex align-items-center gap-1">
            <i class="pi pi-check-circle"></i>
            <app-translate key="PIN_SUCCESSFULLY_VALIDATED"></app-translate>
          </span>
        }
      </div>

      <app-otp-verification [wirelessSetupCustomerOrderPayload]="wirelessSetupCustomerOrderPayload"
        [accountNumber]="accountNumber" [selectedPinDeliveryMethod]="selectedPinDeliveryMethod"
        [pinDeliveryOptions]="pinDeliveryOptions" [showPinFields]="showPinFields"
        [isPinExpired]="isPinExpired" (pinValidated)="onPinValidated($event)"
      (connectionError)="onConnectionError()"></app-otp-verification>
    </div>

  </div>

  <div class="flex flex-column gap-2 pt-4 mt-2">
    <p-button [styleClass]="'w-full'" [label]="languageService.getTranslation('SUBMIT')"
    (click)="submitClicked()" [disabled]="!isPinValidated"></p-button>
    <p-button [label]="languageService.getTranslation('CANCEL')" [link]="true" styleClass="w-full"
    (onClick)="onCancelClick()"></p-button>
    <div class="text-xs text-color-secondary text-center">
      <app-translate key="PRIVATE_INFO_SECURITY"></app-translate>
    </div>
  </div>
</div>

<!-- Wireless Account Validation success modal -->
<app-confirm-popup [header]="languageService.getTranslation('WIRELESS_ACCOUNT_VALIDATION_HEADER')"
  [title]="languageService.getTranslation('WIRELESS_ACCOUNT_VALIDATION_MESSAGE')"
  [buttonLabel]="languageService.getTranslation('OKAY')" [isVisible]="showValidationSuccessModal"
(isVisibleChange)="onValidationModalVisibilityChange($event)"></app-confirm-popup>

<!-- Confirm Cancellation modal -->
<app-confirm-popup [title]="languageService.getTranslation('CANCEL_CONFIRMATION_TEXT')"
  [header]="languageService.getTranslation('CONFIRM_CANCELLATION')" [(isVisible)]="showCancelDialog"
(Result)="onCancel($event)"></app-confirm-popup>

<!-- Clear Selection confirmation modal -->
<app-confirm-popup [title]="languageService.getTranslation('CLEAR_SELECTION_CONFIRMATION_TEXT')"
  [header]="languageService.getTranslation('CLEAR_SELECTION')" [(isVisible)]="showClearSelectionDialog"
(Result)="onClearSelection($event)"></app-confirm-popup>